/**
 * 主页
 *
 * 按照这个风格写就可以
 */

export default [
    {
        path: '',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('../../views/home.vue'),
        meta: {
            title: '首页'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/home/home.js